<template>
  <div class="pick-container">
    <!--  :class="{'mask':isShowMask}" -->
    <div :class="{'mask':isShowMask}"></div>
    <div  class="level-dialog"  v-if="isLevel" >
      <div class="text">抱歉，修理工无权限参与活动</div>
      <div class="btn" @click="goHome">
        返回首页
      </div>
    </div>
    <div  class="over-dialog"  v-if="isOveracyivity" >
      <img class="rule" src="../../../assets/images/activity/pickStar/activity-over.png" alt="">
      <img class="close" @click="closeOver" src="../../../assets/images/activity/pickStar/pickStar-close.png" alt="">
    </div>
    <div v-if="isShowHome" class="showHome" >
      <div class="pick-star-rule" @click="activityRule"></div>
      <div class="header"></div>
      <van-notice-bar :scrollable="false" class="scroll-list" v-if="!isActivityfinished">
        <van-swipe
        vertical
        class="swipe"
        :autoplay= "5000"
        :show-indicators="false"
        >
        <van-swipe-item  v-for="(item) in scrollList" :key="item.actionTime">
        <span class="small">恭喜</span>
        <!-- <span class="big">{{(item.clientName).substr(0,2)}}</span>
        <span class="big">***</span>
        <span class="big">{{(item.clientName).substr(-2)}}</span> -->
        <span class="big">{{item.clientName}}</span>
        <span class="small">获得</span>
        <span class="red">{{item.itemName}}</span>
        </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
      <div class="taday-task" v-if="!isActivityfinished">
        <div class="task-empty"></div>
        <div class="task-header">
          <div class="left">
          <span class="black">今日已完成</span>
          <span class="red">{{finshTimes}}</span>
          <span class="blue">/4</span>
          <span class="black">个任务</span>
          </div>
          <div class="right"  @click="goMygift">
            <span class="blue">查看我的获奖</span>
            <img class="img" src="../../../assets/images/activity/pickStar/pickStar-right.png" alt="">
          </div>

        </div>
        <div class="item">
          <div class="item-left">
            浏览易加商城15s
          </div>
          <div class="item-right">
            <div class="go" @click="goBrowse" v-if="status.browseStatus == 0"   ></div>
            <!-- <div class="finsh"  v-if="status.browseStatus == 1 && this.pickStarTimes > 0"></div> -->
            <div class="end"  v-if="status.browseStatus == 1 "></div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            扫博世产品二维码
            <p class="item-p">
              <span>*</span>
              <span>请微信关注易加网公众号后扫码积分</span>
            </p>
          </div>
          <div class="item-right">
            <div class="go" @click="goCode"  v-if="status.codeStatus == 0"></div>
            <!-- <div class="finsh" @click="goPickStar" v-if="status.codeStatus == 1 && this.pickStarTimes > 0"></div> -->
            <div class="end"  v-if="status.codeStatus == 1 "></div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            今日签到
          </div>
          <div class="item-right">
            <!--  @click="goSign('/#/sianIn')"-->
            <div class="go" @click="goSign()" v-if="status.signStatus == 0"></div>
            <!-- <div class="finsh" @click="goPickStar" v-if="status.signStatus == 1 && this.pickStarTimes > 0"></div> -->
            <div class="end"  v-if="status.signStatus == 1"></div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            去易加商城兑换礼品
          </div>
          <div class="item-right">
            <div class="go" @click="goMall"  v-if="status.mallStatus == 0"></div>
            <!-- <div class="finsh" @click="goPickStar" v-if="status.mallStatus == 1 && this.pickStarTimes > 0"></div> -->
            <div class="end"  v-if="status.mallStatus == 1"></div>
          </div>
        </div>
        <div class="task-bottom" @click="openRankingList">
        </div>
      </div>
      <div v-if="this.pickStarTimes > 0" class="button-pick" @click="goPickStar" ></div>
      <div v-if="this.pickStarTimes == 0 && this.isActivityfinished == false" class="button-pick2" @click="goPickStar" ></div>
      <!-- <div v-if="this.pickStarTimes == 0 && this.isActivityfinished == true" class="button-pick3" @click="goPickStar" ></div> -->
      <div class="taday-tip" v-if="!isActivityfinished">
        <span class="sapn-black">今日剩余</span>
        <span class="span-yellow">{{pickStarTimes}}</span>
        <span class="sapn-black">次机会</span>
      </div>
      <div class="ranking-list-finish" v-if="isActivityfinished" >
        <div class="task-empty"></div>
        <div class="ranking-list-items">
          <div class="item-top" >
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                offset="10"
                ref="vanOnload"
                :immediate-check="false"
                @load="onLoad">
                <van-cell class="item" v-for=" (item,index) in rankingList" :key="item.ranking" :class="{'top-three': index < 3}" >
                  <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="left">{{item.ranking}}</div>
                  <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="center van-ellipsis">{{item.clientName}}</div>
                  <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="right">{{item.count}}次</div>
                </van-cell>
            </van-list>
          </div>

          <div class="line">
            <p class="solid"></p>
            <p class="line-text">我的排名</p>
            <p class="solid"></p>
          </div>
          <div class="item-bottom">
            <!-- v-for="(item2) in userRankinglist" :key="item2.clientId"  -->
            <div class="item2" >
            <div class="left">{{userRankinglist.ranking}}</div>
            <div class="center van-ellipsis">{{userRankinglist.clientName}}</div>
            <div class="right">{{userRankinglist.count}}次</div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-gift-finish" v-if="isActivityfinished" >
          <div class="gift-main">
            <div class="task-empty"></div>
            <div class="title">
              <span class="black">本次活动已获得</span>
              <span class="red">{{allTimes}}</span>
              <span class="black">次抽奖机会</span>
            </div>
            <div class="gift-dialog-items">
              <!-- :key="item.clientId" -->
              <div class="item" v-for="(item) in giftList" :key="item.createDate">
              <div class="left">
                {{timestampToTime(item.actionTime)}}
              </div>
              <div class="right  van-ellipsis">
                {{item.itemName}}
              </div>
            </div>
            </div>
            <div class="gift-dialog-btn">
              <div class="left" @click="goMycard">
              </div>
              <div class="right" @click="goMyintegral">
              </div>
            </div>
          </div>
      </div>
      <div class="gift-list">
        <div class="gift-box">
          <div class="gift-item" v-for="(item) in giftUrlList" :key="item.itemId" @click="gotoWeb('shop',item.itemId)">
              <img class="img" :src="getImageUrl(item.itemImageUri)" alt=""/>
              <div class="bottom">
                <div class="bot-1">
                  <div class="item-discount">折扣</div>
                  <div class="item-discount2">
                    <div class="value"> {{item.itemName}}</div>
                  </div>
                </div>
                <div class="item-price-after">
                  <span class="item-price-after-sp"><span class="jf">积分</span>{{item.promotionPoint}}</span>
                  <span class="item-price-before"> <span class="jf">积分</span>{{item.basePoint}}</span></div>
              <div>
              </div>
              </div>
              <!-- <img class="img" :src="require('../../../assets/images/activity/pickStar/' + item)" alt=""/> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 规则 dialog -->
    <div class="rule-dialog " v-if="isShowRule" >
      <img class="rule" src="../../../assets/images/activity/pickStar/pickStar-rule.png" alt="">
      <img class="close" @click="closeRule" src="../../../assets/images/activity/pickStar/pickStar-close.png" alt="">
    </div>
    <!-- 我的获奖明细 dialog -->
    <div class="my-gift-dialog" v-if="isShowGifts" >
    <div class="gift-main">
      <div class="title">
        <span class="black">本次活动已获得</span>
        <span class="red">{{allTimes}}</span>
        <span class="black">次抽奖机会</span>
      </div>
      <div class="gift-dialog-items">
        <!-- :key="item.clientId" -->
        <div class="item" v-for="(item) in giftList" :key="item.createDate">
        <div class="left">
          {{timestampToTime(item.actionTime)}}
        </div>
        <div class="right  van-ellipsis">
          {{item.itemName}}
        </div>
      </div>

      </div>
      <div class="gift-dialog-btn">
        <div class="left" @click="goMycard">
        </div>
        <div class="right" @click="goMyintegral">
        </div>

      </div>
      <div class="gift-dialog-close" @click="closeGift">
        <img class="img" src="../../../assets/images/activity/pickStar/pickStar-close.png" alt="">
      </div>

    </div>
    <div class="gift-close"></div>
    </div>
    <!-- 实时排行榜 dialog -->
    <div class="ranking-list-dialog" v-if="isShowRanking" >
    <div class="ranking-list-items">
      <div class="item-top" >
        <!-- ,'top-onself':index = (userRankinglist.ranking) -->
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="10"
            ref="vanOnload"
            :immediate-check="false"
            @load="onLoad">
            <van-cell class="item" v-for=" (item,index) in rankingList" :key="item.ranking" :class="{'top-three': index < 3}" >
              <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="left">{{item.ranking}}</div>
              <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="center van-ellipsis">{{item.clientName}}</div>
              <div :class="{'top-onself': item.ranking === (userRankinglist.ranking)}" class="right">{{item.count}}次</div>
            </van-cell>
        </van-list>
      </div>

      <div class="line">
        <p class="solid"></p>
        <p class="line-text">我的排名</p>
        <p class="solid"></p>
      </div>
      <div class="item-bottom">
        <!-- v-for="(item2) in userRankinglist" :key="item2.clientId"  -->
        <div class="item2" >
        <div class="left">{{userRankinglist.ranking}}</div>
        <div class="center van-ellipsis">{{userRankinglist.clientName}}</div>
        <div class="right">{{userRankinglist.count}}次</div>
        </div>
      </div>
    </div>
    <div class="ranking-list-close" @click="closeRanking">
      <img class="img" src="../../../assets/images/activity/pickStar/pickStar-close.png" alt="">
    </div>
    </div>
    <picker-star
     v-if="isShowPickStar"
     @closePickStar="closePickStar"
     @goMycard="goMycard"
     @goMyintegral="goMyintegral"
     >
     </picker-star>
  </div>
</template>
<script>
import PickerStar from '../components/activity-star-pick-pop.vue'
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      isShowPickStar: false, // 展示摘星组件
      isShowHome: true, // 展示首页
      isShowRule: false, // 展示规则
      isShowGifts: false, // 展示我的奖品
      isShowRanking: false, // 展示实时排行榜
      isShowMask: false, // 展示蒙层
      datalist: [], // 数据列表
      rankingList: [], // 获取实时排行数据列表
      userRankinglist: [], // 用户任务排名
      giftList: [], // 获奖明细列表
      giftUrlList: [], // 礼品展示列表
      scrollList: [], // 滚动展示数据列表
      status: {
        browseStatus: '', // 浏览状态
        codeStatus: '', // 扫码状态
        signStatus: '', // 签到状态
        mallStatus: '' // 商城状态
      },
      pickStarTimes: '', // 剩余摘星次数
      allTimes: '', // 活动完成总任务次数
      finshTimes: 0, // 当日完成任务数
      page: 1, // 默认展示第一页
      loading: false,
      finished: false,
      isLevel: false,
      level: '',
      isActivityfinished: false, // 活动是否结束
      isOveracyivity: false // 是否展示结束dialog
    }
  },
  components: {
    PickerStar
  },
  created () {
    // this.activityEnd()
    if (!localStorage.getItem('userInfo')) {
      console.log('未登录')
      this.$router.push({ name: 'login2', query: { pickStar: 1 } })
    } else {
      // let data ={
      //   activityCode : 'PartsBeyond'
      // }
      commonUtils.reportViewTrace()
      let level = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole
      this.level = level
      console.log(level, 'level-userinfo')
      if (this.level === '03') {
        this.isLevel = true
        this.isShowMask = true
      } else {
        this.isLevel = false
        if (this.isActivityfinished === true) {
          this.getUrllist()
          this.getRanking()
          this.getAlllist()
        } else {
          this.getAlllist()
          this.getUrllist()
          this.getScroll()
          this.getRanking()
        }
      }
    }
  },
  mounted () {
    this.initWxJsSdk()
  },
  updated () {},
  methods: {
    // 初始化微信jssdk
    initWxJsSdk () {
    // console.log(window.__wxjs_is_wkwebview)
    // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }

      const url = `${document.location.origin}/v2/activity/2022/activity-star-pick`
      console.log(url, 'appMessageShare--url')
      const appMessageShare = {
        title: '百万积分大奖等你拿', // 分享标题
        desc: '每日做任务领取抽奖机会，可得多种好礼!', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/star-share.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }
      const timelineShare = {
        title: '百万积分大奖等你拿', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/star-share.png', // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    closeOver () {
      this.isOveracyivity = false
      this.isShowMask = false
    },
    // 判断活动是否结束
    activityEnd () {
      activityApi.getActivitystar().then(res => {
        if (res.data.resultCode === '0') {
          let endDate = res.data.resultData.activityEndDate
          let nowDate = new Date().getTime()
          if (nowDate - endDate > 0) {
            console.log('当前时间大于活动结束时间')
            this.isActivityfinished = true
          } else {
            console.log('当前时间小于活动结束时间')
            this.isActivityfinished = false
          }
        }
      })
    },
    timestampToTime (timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return ''
      } else {
        var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + '-'
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D
      }
    },
    // 底部刷新排名
    onLoad () {
      let page = this.page + 1
      let params = {
        page: page,
        pageSize: 6
      }
      activityApi.getRanking(params).then(res => {
        if (res.data.resultCode === '0') {
          // this.scrollList = res.data.resultData.prizeList
          let itemList = res.data.resultData.taskRankingList
          this.rankingList = this.rankingList.concat(itemList)
          this.loading = false
          this.page++
          if (res.data.resultData.taskRankingList < 5) {
            this.finished = true
          }
        }
      })
    },
    // 获取滚动数据
    getScroll () {
      activityApi.getSroll().then(res => {
        if (res.data.resultCode === '0') {
          this.scrollList = res.data.resultData.prizeList
        }
      })
    },
    getRanking () {
      let params = {
        page: this.page,
        pageSize: 6
      }
      activityApi.getRanking(params).then(res => {
        if (res.data.resultCode === '0') {
          this.rankingList = res.data.resultData.taskRankingList
        }
      })
    },
    getAlllist () {
      activityApi.getActivitystar().then(res => {
        if (res.data.resultCode === '0') {
          let data = res.data.resultData
          this.giftList = data.activityLotteryList
          this.userRankinglist = data.currClientTaskRanking
          let endDate = data.activityEndDate
          let nowDate = new Date().getTime()
          if (nowDate - endDate > 0) {
            console.log('当前时间大于活动结束时间')
            this.isActivityfinished = true
            this.isOveracyivity = true
            this.isShowMask = true
          } else {
            console.log('当前时间小于活动结束时间')
            this.isActivityfinished = false
            // this.isOveracyivity = false
            // this.isShowMask = false
          }

          if (this.isActivityfinished === false) {
            this.pickStarTimes = data.availableLotteryCount
            this.allTimes = data.allTaskCount
            this.finshTimes = data.currTaskCount
            this.status.browseStatus = data.mallTask
            this.status.codeStatus = data.scanTask
            this.status.mallStatus = data.orderTask
            this.status.signStatus = data.signTask
            if (this.pickStarTimes < 0) {
              this.pickStarTimes = 0
            }
          } else {
            this.pickStarTimes = 0
            this.allTimes = data.allTaskCount
            this.finshTimes = 0
            this.status.browseStatus = 1
            this.status.codeStatus = 1
            this.status.mallStatus = 1
            this.status.signStatus = 1
          }
        }
      })
    },
    getUrllist () {
      activityApi.getUrlstar().then(res => {
        if (res.data.resultCode === '0') {
          let data = res.data.resultData
          this.giftUrlList = data.itemList
        }
      })
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    gotoWeb (type, itemId) {
      // if (type === 'rank') {
      //   this.$router.push({ name: 'activity-2022-scan-rank' })
      // } else if (type === 'shop') {
      //   // window.location.href = commonUtils.getExtraSite() + `/#/goodsDetail/${itemId}`
      //   window.location.href = commonUtils.getExtraSite() + `/v2/goods-detail?itemId=${itemId}`
      // } else if (type === 'cart') {
      //   window.location.href = commonUtils.getExtraSite() + `/#/tab/cart`
      // }
      // window.location.href = commonUtils.getExtraSite()
      this.$router.push({ name: 'goods-detail', query: { itemId: itemId } })
    },
    // 打开实施排行dialog
    openRankingList () {
      this.isShowMask = true
      this.isShowRanking = true
    },
    // 关闭实时排行dialog
    closeRanking () {
      this.isShowMask = false
      this.isShowRanking = false
      if (this.isActivityfinished === false) {
        this.getAlllist()
      }
    },
    // 查看我的获奖
    goMygift () {
      this.isShowMask = true
      this.isShowGifts = true
    },
    // 关闭获奖dialog
    closeGift () {
      this.isShowMask = false
      this.isShowGifts = false
      if (this.isActivityfinished === false) {
        this.getAlllist()
      }
    },
    // 去查看我的卡劵
    goMycard () {
      this.$router.push({ name: 'userCoupon' })
    },
    // 去查看我的积分
    goMyintegral () {
      this.$router.push({ name: 'user-integration' })
    },
    // 去浏览商城
    goBrowse () {
      // this.$bus.emit('lowerRight', 1)
      this.$router.push({ name: 'home-main', query: { pickStar: 'pick-h5' } })
    },
    goHome () {
      this.$router.push({ name: 'home-main' })
    },
    // 去扫码
    goCode () {
      this.$router.push({ name: '2022-scan-first-half' })
    },
    // 去签到
    goSign (path) {
      this.$router.push({ name: 'signIn' })
    },
    // 去易加商城兑换礼品
    goMall () {
      this.$router.push({ name: 'home-main' })
    },
    // 点击规则
    activityRule () {
      if (this.isShowMask === false && this.isShowGifts === false && this.isShowRanking === false) {
        this.isShowMask = true
        this.isShowRule = true
      }
    },
    closeRule () {
      this.isShowMask = false
      this.isShowRule = false
    },
    // 去摘星游戏页面
    goPickStar () {
      if (this.isActivityfinished === false) {
        this.getAlllist()
        if (this.isShowRanking === false && this.isShowGifts === false && this.isShowRule === false) {
          if (this.pickStarTimes > 0) {
            this.isShowHome = false
            this.isShowPickStar = true
            // this.$nextTick(() => {
            //   this.isShowPickStar = true
            // })
          } else {
            this.$toast('抱歉，您暂无抽奖机会')
          }
        }
      } else {
        this.$toast('活动已结束')
      }
    },
    // 关闭摘星游戏页面
    closePickStar () {
      this.isShowPickStar = false
      this.isShowHome = true
      if (this.isActivityfinished === false) {
        this.getAlllist()
      }
    }
  }
}
</script>
<style lang="less" scoped>
 @keyframes scaleDraw {  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0%{
  transform: scale(1);  /*开始为原始大小*/
  }

  25%{
  transform: scale(1.1); /*放大1.1倍*/
  }

  50%{
  transform: scale(1);
  }

  75%{
  transform: scale(1.1);
  }
}
.mask{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.7) ;
  z-index: 3;
}
.pick-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  // padding-bottom: 15px;
  // background: url("../../../assets/images/activity/pickStar/pickStar-bj.jpg") no-repeat;
  // background-size: 100% auto;
  box-sizing: border-box;
  .showHome{
    position:relative;
    width: 100%;
    min-height: 100%;
    background: url("../../../assets/images/activity/pickStar/pickStar-bj.jpg") no-repeat;
    background-size: 100% auto;
    background-color: rgb(48, 184, 208);
    // height: 100%;
    .pick-star-rule{
      position: absolute;
      left: 0;
      top: 133px;
      width: 33.3px;
      height: 67.7px;
      // background: red;
      z-index: 2;
      background: url("../../../assets/images/activity/pickStar/pickStar-btn-rule.png");
      background-size: 100% auto;
    }
    .header{
      width: 100%;
      height: 166.7px;
    }
    .scroll-list{
      width: 333.3px;
      height: 33.3px;
      line-height: 33.3px;
      margin: 0 auto;
      background: url("../../../assets/images/activity/pickStar/pickStar-bj-zjxx.png")  no-repeat;
      background-size: 100% auto;
      border-radius: 5px;
      // display: flex;
      // justify-content: center;
      overflow-y: auto;
      .swipe{
      width: 333.3px;
      height: 33.3px;
      line-height: 33.3px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      text-align: center;
      .small{
        color: #000000;
        font-size: 12px;
        font-weight: 500;
      }
      .big{
        color: #000000;
        font-size: 12px;
        font-weight: 600;
        margin: 0 4px 0 4px;
      }
      .red{
        color: rgb(212, 37, 31);
        font-size: 12px;
        font-weight: 600;
        margin: 0 4px 0 4px;
      }

      }

    }
    .taday-task{
      position: relative;
      width: 333.3px;
      height: 333.3px;
      margin: 0 auto;
      margin-top: 20px;
      background: url("../../../assets/images/activity/pickStar/pickStar-today.png") no-repeat;
      background-size: 100% auto;
      .task-empty{
        width: 333.3px;
        height: 51px;
      }
      .task-header{
        width: 296px;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        border-radius: 5px;
        background: url("../../../assets/images/activity/pickStar/pickStar-bj-rwjd.png") no-repeat;
        background-size: 100% auto;
        display: flex;
        // justify-content: space-around;
        .left{
          width: 166.7px;
          text-align: center;
          font-weight: 600;
          margin-right: 30px;
          .black{
            color: #000000;
          }
          .red{
            color: rgba(212, 37, 31);
            margin-left: 3px;
          }
          .blue{
            color: rgba(17, 113, 129);
            margin-right: 3px;

          }

        }
        .right{
          width: 100px;
          text-align: left;
          font-weight: 400;
          .blue{
            color: rgba(17, 113, 129);
            margin-right: 3px;
            font-size: 11px;
          }
          .img{
            width: 13px;
            height: 10px;
          }
        }
      }
      .item{
        margin-top: 22.3px;
        margin-left: 31px;
        width: 270.6px;
        height: 20px;
        line-height: 20px;
        display: flex;
        .item-left{
          width: 213px;
          text-align: left;
          // font-size: 30px;
          font-weight: 600;
          color: #000000;
          position: relative;
          .item-p {
            position: absolute;
            top:15px;
            color: #BBBBBB;
            font-size:10px;
            font-weight:normal;
          }

        }
        .item-right{
          flex: 1;
          text-align: center;
          // width: 55px;
          // height: 22px;
          .go{
            width: 55px;
            height: 23px;
            background: url("../../../assets/images/activity/pickStar/pickStar-btn-go.png") no-repeat;
            background-size: 100% auto;
          }
          .finsh{
            width: 55px;
            height: 23px;
            background: url("../../../assets/images/activity/pickStar/go-pick-star.png") no-repeat;
            background-size: 100% auto;
          }
          .end{
            width: 55px;
            height: 23px;
            // background: url("../../../assets/images/activity/pickStar/go-pick-end.png") no-repeat;
            background: url("../../../assets/images/activity/pickStar/pickStar-btn-finsh.png") no-repeat;
            background-size: 100% auto;
          }
        }
      }
      .task-bottom{
        width: 133.3px;
        height: 33.3px;
        line-height: 33.3px;
        margin: auto;
        margin-top: 18px;
        text-align: center;
        background: url("../../../assets/images/activity/pickStar/pickStar-btn-ssph.png") no-repeat;
        background-size: 100% auto;

      }

    }
    .button-pick{
    animation: scaleDraw 3s ease-in-out infinite;
    width: 216.7px;
    height: 48.7px;
    line-height: 48.7px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
    background: url("../../../assets/images/activity/pickStar/pickStar-btn-gopick.png") no-repeat;
    background-size: 100% auto;
    }
    .button-pick2{
    width: 216.7px;
    height: 48.7px;
    line-height: 48.7px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
    background: url("../../../assets/images/activity/pickStar/pick-no-time.png") no-repeat;
    background-size: 100% auto;
    }
    .button-pick3{
    width: 216.7px;
    height: 48.7px;
    line-height: 48.7px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
    background: url("../../../assets/images/activity/pickStar/pick-activity-finsh.png") no-repeat;
    background-size: 100% auto;
    }
    .taday-tip{
      width: 100%;
      height: 45.3px;
      line-height: 45.3px;
      text-align: center;
      .sapn-black{
        font-size: 16px;
        font-weight: 600;
      }
      .span-yellow{
        font-size: 18px;
        font-weight: 600;
        color: rgba(239, 232, 108);
        margin: 0 5px;
      }
    }
    .gift-list{
      width: 327.3px;
      height: 431px;
      margin: 0 auto;
      margin-top: 11px;
      background: url("../../../assets/images/activity/pickStar/pickStar-bj-gift.png") no-repeat;
      background-size: 100% auto;
      padding-top: 34px;
      .gift-box{
        margin: 0 auto;
        width: 296.7px;
        height: 373.3px;
        display: flex;
        // justify-content: space-around;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        overflow-y:scroll;
        .gift-item{
        width: 129px;
        height: 160px;
        margin-top: 16.7px;
        border-radius: 10px;
        border: 1px solid #414141;
        margin-right: 8px;
        margin-left: 8px;
        .img{
        width: 129px;
        height: 110px;
        background-size: 100% auto;
        border-radius: 10px;
        }
        .bottom{
          width: 129px;
          margin-left: 3px;
          .bot-1{
            width: 129px;
            border: 1px soild red;
            display: flex;
            align-items: center;
            .item-discount{
            width: 28px;
            text-align: center;
            background-color: rgb(218, 0, 0);
            color: rgb(255, 255, 255);
            border-radius: 5px;
            padding: 0 3px;
            font-size: 10px;
            margin-right: 2px;
            transform: scale(0.86);
          }
            .item-discount2{
              flex: 1;
              min-width: 0;
              .value {
                width: 90%;
                padding: 0 3px;
                font-size: 10px;
                overflow: hidden;//溢出隐藏
                text-overflow: ellipsis;//超出省略号显示
                white-space: nowrap;//文字不换行
              }
            }
          }

          .item-price-after{
            color: rgb(247, 0, 0);
            width: 97%;
            margin-left: 1.5%;
          }

          .item-price-after-sp{
            font-size: 14px;
            font-weight:600;
            .jf{
            font-size: 12px;
            font-weight:normal;
          }
          }
          .item-price-before{
            margin-left: 5px;
            color: grey;
            text-decoration:line-through;
            font-size: 9px;
            .jf{
            font-size: 9px;
          }
          }
        }
      }
      // :last-child :nth-child(2n+1){
      // }
      // :nth-child(11){
      //   margin-bottom: 10px;
      // }
      // :nth-child(12){
      //   margin-bottom: 10px;
      // }
      }
    }
    .my-gift-finish{
      width: 325px;
      height: 330px;
      margin: 0 auto;
      margin-top: 20px;
      position: relative;
      background: url(../../../assets/images/activity/pickStar/pickStar-bj-mygift3.png) no-repeat;
      background-size: 100% auto;
      .gift-main{
        .task-empty{
          width: 333.3px;
          height: 51px;
        }
        .title{
          width: 286.7px;
          height: 40px;
          line-height: 40px;
          margin: 0 auto;
          background-color: rgb(236,244,245);
          text-align: center;
          font-weight: 600;
          .red{
            color: rgb(212, 37, 31);
            font-size: 20px;
            margin-left: 3px;
            margin-right: 3px;
          }

        }
        .gift-dialog-items{
          width: 325px;
          height: 160px;
          overflow-y: scroll;
          .item{
            width: 100%;
            height: 40px;
            line-height: 40px;
            // background-color: #000000;
            display: flex;
            justify-content: center;
            font-weight: 500;
            .left {
              margin-left: 30px;
              width: 150px;
              text-align: left;
            }
            .right {
              flex: 1;
              margin-right: 20px;
              // text-align: center;

            }
          }
        }
        .gift-dialog-btn{
          width: 100%;
          height: 33.3px;
          margin-top: 10px;
          display: flex;
          justify-content: center;
          .left{
            width: 133.3px;
            height: 33.3px;
            line-height: 33.3px;
            text-align: center;
            margin-right: 10px;
            background: url(../../../assets/images/activity/pickStar/pickStar-btn-mycard.png) no-repeat;
            background-size: 100% auto;
          }
          .right{
            width: 133.3px;
            height: 33.3px;
            line-height: 33.3px;
            text-align: center;
            background: url(../../../assets/images/activity/pickStar/pickStar-btn-myintegral.png) no-repeat;
            background-size: 100% auto;

          }
        }
      }
    }
    .ranking-list-finish{
      width: 330px;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 25px;
      position: relative;
      background: url(../../../assets/images/activity/pickStar/pickStar-bj-phb3.png) no-repeat;
      background-size: 100% auto;
      .task-empty{
          width: 333.3px;
          height: 51px;
        }
      .ranking-list-items{
        width: 297.7px;
        margin: 0 auto;
        .item-top{
          height: 270px;
          overflow-y: scroll;
          .item{
            color: #000000;
            width: 297.7px;
            // height: 39.3px;
            // line-height: 39.3px;
            margin: 0 auto;
            margin-top: 8px;
            text-align: center;
            // display: flex;
            // justify-content: space-around;
            border-radius: 10px;
            ::v-deep.van-cell {
                background-color: rgba(255, 255, 255,.1);
            }
          .left{
            // margin-left: 30px;
            display:inline-block;
            width: 20%;
          }
          .center{
            display: inline-block;
            width: 50%;
            text-align: left;
          }
          .right{
            margin-left: 20px;
            display: inline-block;
            width: 20%;
          }
        }
        }
        .line{
          position: absolute;
          bottom: 35px;
          width: 297.7px;
          height: 39.3px;
          line-height: 39.3px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          font-size: 12px;
          color: rgb(225, 225, 225);
          .solid{
            flex: 1;
            height: 1px;
            line-height: 1px;
            position: relative;
            top: 20px;
            background-color: rgb(225, 225, 225);
          }
          .line-text {
            color: #101010;
          }
        }
        .item-bottom{
          .item2{
            color: #cd1231;;
            width: 297.7px;
            height: 49.3px;
            line-height: 49.3px;
            margin: 0 auto;
            margin-top: 20px;
            text-align: center;
            border-radius: 10px;
            display: flex;
            .left{
              margin-left: 17px;
              width: 20%;
              text-align: left;
            }
            .center{
              width: 45%;
              text-align: left;
              margin-left: -9px;
            }
            .right{
              margin-left: 6px;
              width: 20%;
            }
          }
        }
      }
    }
  }
  .rule-dialog{
    width: 327px;
    height: 400px;
    position: absolute;
    top: 196px;
    left: 24px;
    z-index: 9;
    .rule{
      width: 327px;
    }
    .close{
      width: 40px;
      margin-left: 140px;
      z-index: 9;

    }

  }
  .my-gift-dialog{
    width: 325px;
    height: 390px;
    position: absolute;
    top: 196px;
    left: 24px;
    z-index: 9;
    background: url(../../../assets/images/activity/pickStar/pickStar-bj-mygift3.png) no-repeat;
    background-size: 100% auto;
    .gift-main{
      width: 325px;
      height: 330px;
      .title{
        width: 286.7px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 52px;
        // background: url(../../../assets/images/activity/pickStar/pickStar-bj-picktimes.png) no-repeat;
        // background-size: 100% auto;
        background-color: rgb(236,244,245);
        text-align: center;
        font-weight: 600;
        .red{
          color: rgb(212, 37, 31);
          font-size: 20px;
          margin-left: 3px;
          margin-right: 3px;
        }

      }
      .gift-dialog-items{
        height: 160px;
        overflow-y: scroll;
        .item{
        width: 100%;
        height: 40px;
        line-height: 40px;
        // background-color: #000000;
        display: flex;
        justify-content: center;
        font-weight: 500;
        .left {
          margin-left: 30px;
          width: 150px;
          text-align: left;
        }
        .right {
          flex: 1;
          margin-right: 20px;
          // text-align: center;

        }
      }
      }
      .gift-dialog-btn{
        width: 100%;
        height: 33.3px;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        .left{
          width: 133.3px;
          height: 33.3px;
          line-height: 33.3px;
          text-align: center;
          margin-right: 10px;
          background: url(../../../assets/images/activity/pickStar/pickStar-btn-mycard.png) no-repeat;
          background-size: 100% auto;
        }
        .right{
          width: 133.3px;
          height: 33.3px;
          line-height: 33.3px;
          text-align: center;
          background: url(../../../assets/images/activity/pickStar/pickStar-btn-myintegral.png) no-repeat;
          background-size: 100% auto;

        }
      }
      .gift-dialog-close{
        height: 40px;
        margin-top: 40px;
        .img{
          width: 40px;
          height: 40px;
          margin-left: 143px;
        }
      }
    }
  }
  .ranking-list-dialog{
    width: 330px;
    // height: 351.7px;
    position: absolute;
    top: 196px;
    left: 24px;
    z-index: 9;
    background: url(../../../assets/images/activity/pickStar/pickStar-bj-phb3.png) no-repeat;
    background-size: 100% auto;
    .ranking-list-items{
      width: 297.7px;
      // height: 335px;
      margin: 0 auto;
      margin-top: 50px;
      // overflow-y: scroll;
      .item-top{
        height: 270px;
        // height: 79%;
        overflow-y: scroll;
        .item{
        color: #000000;
        width: 297.7px;
        // height: 39.3px;
        // line-height: 39.3px;
        margin: 0 auto;
        margin-top: 8px;
        text-align: center;
        // display: flex;
        // justify-content: space-around;
        border-radius: 10px;
        ::v-deep.van-cell {
            background-color: rgba(255, 255, 255,.1);
        }
        .left{
          // margin-left: 30px;
          display:inline-block;
          width: 20%;
        }
        .center{
          display: inline-block;
          width: 50%;
          text-align: left;
        }
        .right{
          margin-left: 20px;
          display: inline-block;
          width: 20%;
        }
      }
      }
      .line{
        position: absolute;
        bottom: 115px;
        width: 297.7px;
        height: 39.3px;
        line-height: 39.3px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        font-size: 12px;
        color: rgb(225, 225, 225);
        .solid{
          flex: 1;
          height: 1px;
          line-height: 1px;
          position: relative;
          top: 20px;
          background-color: rgb(225, 225, 225);
        }
        .line-text {
          color: #101010;
        }
      }
      .item-bottom{
        .item2{
        color: #cd1231;;
        width: 297.7px;
        height: 49.3px;
        line-height: 49.3px;
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
        border-radius: 10px;
        display: flex;
        .left{
          margin-left: 17px;
          width: 20%;
          text-align: left;
        }
        .center{
          width: 45%;
          text-align: left;
          margin-left: -9px;
        }
        .right{
          margin-left: 6px;
          width: 20%;
        }
      }
      }
    }
    .ranking-list-close{
      height: 40px;
      margin-top: 40px;
      .img{
        width: 40px;
        height: 40px;
        margin-left: 143px;
        }
    }
  }
  .level-dialog {
    width: 330px;
    height: 160px;
    position: absolute;
    top: 196px;
    left: 24px;
    z-index: 99;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    .text {
      height: 100px;
      line-height: 100px;
      font-size: 18px;
      font-weight: 600;
    }
    .btn {
      width: 100px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      border-radius: 5px;
      color: #000000;
      // rgb(170, 219, 233)
      background-color: rgb(17, 114, 129);
      border: 1px solid rgb(17, 114, 129);
      color: #ffffff;

    }
  }
  .over-dialog {
    width: 327px;
    // height: 300px;
    position: absolute;
    top: 22%;
    left: 24px;
    z-index: 9;
    .rule{
      width: 327px;
    }
    .close{
      width: 40px;
      // margin-left: 140px;
      margin: 0 auto;
      margin-left: 140px;
      z-index: 9;

    }

  }
}
.top-three{
        // background: url(../../../assets/images/activity/pickStar/pickStar-bj-finshtimes.png) no-repeat;
        // background-size: 100% auto;
        background-color:rgb(236,244,245) !important ;
      }
.top-onself{
  color:#cd1231 !important;
}

</style>
